export default __webpack_public_path__ + "static/spring-9f9bc118d1e84d31222ed43fcdfff0d3.jpg";